/**
 * WARNING: The order of each item in the lists may be used in conditional statements. Add new items at the end of the
 * array in order to not introduce unwanted behavior throughout the application.
 */

/**
 * List of possible statuses for study cards.
 * NOTE: 'status' is the text displayed, 'color' is the badge dot color,
 * and class is the global.css style to implement to the header.
 */
const cardStatusList = [
	{
		status: 'Active',
		color: 'green',
		// TODO: classes not being used at the moment, delete if not needed after user testing
		class: 'active-card-title'
	},
	{
		status: 'Not Started',
		color: 'yellow',
		class: 'not-started-card-title'
	},
	{
		status: 'Completed',
		color: 'grey',
		class: 'completed-card-title'
	},
	{
		status: 'Draft',
		color: 'grey',
		class: 'completed-card-title'
	}
];

/**
 * Possible messages for the snackbar messages in the landing page
 */
const statusesList = [
	{
		status: 'Your new study has been created',
		color: '#4CAF50'
	},
	{
		status: 'Your study was deleted successfully',
		color: '#4CAF50'
	},
	{
		status: 'Your form was submitted',
		color: '#4CAF50'
	},
	{
		status: 'User registered. Check email for password',
		color: '#4CAF50'
	},
	{
		status: 'Profile information updated succesfully',
		color: '#4CAF50'
	},
	{
		status: 'Password updated succesfully',
		color: '#4CAF50'
	},
	{
		status: 'User details updated succesfully',
		color: '#4CAF50'
	},
	{
		status: 'Respondents were deleted succesfully',
		color: '#4CAF50'
	},
	{
		status: 'Your new draft has been created',
		color: '#4CAF50'
	},
	{
		status: 'Your draft was deleted successfully',
		color: '#4CAF50'
	},
	{
		status: 'Your admin message was submitted successfully',
		color: '#4CAF50'
	},
	{
		status: 'Your recalls were deleted successfully',
		color: '#4CAF50'
	}

];

export default {
	cardStatusList,
	statusesList
}
